import Link from "next/link";
export default function ConsentCheckbox({
  name,
  id,
  checked,
  onChange,
  setOpen,
  error,
  label,
  terms_and_conditions,
  privacy_policy_url,
}) {
  const labelParts = label ? label.split(":terms:") : [label];
  const policyUrl = privacy_policy_url?.trim() || "/privacy-policy";
  // CMS paths must resolve from the site root, including on nested pages.
  // Next Link applies the current tenant's basePath and locale to internal URLs.
  const url = /^(?:[a-z][a-z\d+.-]*:|\/)/i.test(policyUrl)
    ? policyUrl
    : `/${policyUrl}`;
  return (
    <label className={`input-checkbox ${error && "error"}`}>
      <span
        className={`inline items-center gap-x-4 font-medium text-xxs ${error ? "text-red-500" : "text-gray-900"
          }`}
      >
        {labelParts[0] && labelParts[0]}
        <Link
          href={url}
          as={url}
          onClick={() => setOpen && setOpen(false)}
          aria-label={terms_and_conditions || ""}
          className={`btn-link w-fit text-gray-900 underline media-hover:hover:decoration-transparent underline-offset-4 duration-300 ${error
              ? "text-red-500 decoration-red-500"
              : "text-gray-900 decoration-gray-900"
            }`}
        >
          {terms_and_conditions}
        </Link>
        {labelParts[1] && labelParts[1]}
        <span className="text-red-500 ml-4">*</span>
      </span>
      <input
        type="checkbox"
        name={name}
        id={id}
        checked={checked}
        onChange={onChange}
        aria-describedby={id}
      />
      <span className={`checkmark ${error && "error"}`}></span>
    </label>
  );
}
